exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/index.js??postcss!../common.css"), "");

// module
exports.push([module.id, "/* \r\n.costs-h2 {\r\n  margin: 10px;\r\n} */\r\n\r\n/* .costs-section {\r\n  display: flex;\r\n  align-content: center;\r\n  align-items: center;\r\n  height: 60px;\r\n} */\r\n/* \r\n.costs-margin {\r\n  margin: 10px;\r\n} */\r\n/* \r\n.mat-slider-horizontal {\r\n  width: 200px;\r\n}\r\n\r\n.mat-slider-vertical {\r\n  height: 300px;\r\n} */\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/costs/costs.component.css
// module id = ../../../../../src/app/costs/costs.component.css
// module chunks = main